"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initNav = initNav;
// svgs
const apps_svg_1 = __importDefault(require("./assets/image/nav/apps.svg"));
const apps_inactive_svg_1 = __importDefault(require("./assets/image/nav/apps_inactive.svg"));
const browser_svg_1 = __importDefault(require("./assets/image/nav/browser.svg"));
const browser_inactive_svg_1 = __importDefault(require("./assets/image/nav/browser_inactive.svg"));
const cursor_svg_1 = __importDefault(require("./assets/image/nav/cursor.svg"));
const cursor_inactive_svg_1 = __importDefault(require("./assets/image/nav/cursor_inactive.svg"));
const add_download_svg_1 = __importDefault(require("./assets/image/nav/add-download.svg"));
const add_download_inactive_svg_1 = __importDefault(require("./assets/image/nav/add-download_inactive.svg"));
const repair_svg_1 = __importDefault(require("./assets/image/nav/repair.svg"));
const repair_inactive_svg_1 = __importDefault(require("./assets/image/nav/repair_inactive.svg"));
const setting_svg_1 = __importDefault(require("./assets/image/nav/setting.svg"));
const setting_inactive_svg_1 = __importDefault(require("./assets/image/nav/setting_inactive.svg"));
const theme_svg_1 = __importDefault(require("./assets/image/nav/theme.svg"));
const theme_inactive_svg_1 = __importDefault(require("./assets/image/nav/theme_inactive.svg"));
const nav_scss_1 = __importDefault(require("./assets/css/nav.scss"));
const utils_1 = require("./utils");
function initNav(cfg) {
    const navContainer = document.querySelector('#nav');
    navContainer.className = nav_scss_1.default.nav;
    const navItems = [
        {
            key: 'apps',
            desc: 'apps',
            active: apps_svg_1.default,
            inactive: apps_inactive_svg_1.default
        },
        null,
        {
            key: 'browser',
            desc: 'browser',
            active: browser_svg_1.default,
            inactive: browser_inactive_svg_1.default
        },
        null,
        {
            key: 'cursor',
            desc: 'cursor',
            active: cursor_svg_1.default,
            inactive: cursor_inactive_svg_1.default
        },
        null,
        {
            key: 'add-download',
            desc: 'add-download',
            active: add_download_svg_1.default,
            inactive: add_download_inactive_svg_1.default
        },
        null,
        {
            key: 'repair',
            desc: 'repair',
            active: repair_svg_1.default,
            inactive: repair_inactive_svg_1.default
        },
        null,
        {
            key: 'setting',
            desc: 'setting',
            active: setting_svg_1.default,
            inactive: setting_inactive_svg_1.default
        },
        null,
        {
            key: 'theme',
            desc: 'theme',
            active: theme_svg_1.default,
            inactive: theme_inactive_svg_1.default
        }
    ].map(icon => createNavItem(icon));
    const setActive = (iconTitle) => {
        const prevNavItemIndex = navItems.findIndex(item => item.active);
        const nextNavItemIndex = navItems.findIndex(item => item.icon && item.icon.key === iconTitle);
        // no previous nav item actived, use appearBottom
        if (prevNavItemIndex < 0) {
            setActiveNavItem(navItems[nextNavItemIndex], true, 'bottom');
        }
        else {
            if (nextNavItemIndex > prevNavItemIndex) {
                // fade left, appear left
                setActiveNavItem(navItems[prevNavItemIndex], false, 'left');
                setActiveNavItem(navItems[nextNavItemIndex], true, 'left');
            }
            else if (nextNavItemIndex < prevNavItemIndex) {
                // fade right, appear right
                setActiveNavItem(navItems[prevNavItemIndex], false, 'right');
                setActiveNavItem(navItems[nextNavItemIndex], true, 'right');
            }
        }
        // navItems.forEach(navItem => {
        //   setActiveNavItem(navItem, icon === navItem.icon);
        // })
    };
    const onWheel = (e) => {
        const currNavItemIndex = navItems.findIndex(item => item.active);
        if (currNavItemIndex < 0)
            return;
        if (e.deltaY > 0) {
            // next
            const nextItem = navItems.find((item, index) => {
                if (index <= currNavItemIndex)
                    return false;
                if (!item.icon)
                    return false;
                return true;
            });
            if (nextItem) {
                setActive(nextItem.icon.key);
            }
            else {
                setActive('apps');
            }
        }
        else {
            // prev
            const prevItem = navItems.slice().reverse().find((item, index) => {
                if (index <= navItems.length - 1 - currNavItemIndex)
                    return false;
                if (!item.icon)
                    return false;
                return true;
            });
            if (prevItem) {
                setActive(prevItem.icon.key);
            }
            else {
                setActive('theme');
            }
        }
    };
    const onWheelDebounced = (0, utils_1.debounceAdv)(onWheel);
    navItems.forEach(item => {
        item.domNode.addEventListener('click', () => {
            if (item.icon) {
                setActive(item.icon.key);
            }
        });
    });
    navContainer === null || navContainer === void 0 ? void 0 : navContainer.append(...navItems.map(i => i.domNode));
    if (cfg.activeIcon) {
        setActive(cfg.activeIcon);
    }
    // add scroll listener
    window.addEventListener('wheel', onWheelDebounced);
}
function fadeCallback(target, dir) {
    target.classList.add('none');
    switch (dir) {
        case 'left':
            target.classList.remove(nav_scss_1.default.fadeLeft);
            break;
        case 'right':
            target.classList.remove(nav_scss_1.default.fadeRight);
            break;
        case 'top':
            target.classList.remove(nav_scss_1.default.fadeTop);
            break;
        case 'bottom':
            target.classList.remove(nav_scss_1.default.fadeBottom);
            break;
    }
}
function appearCallback(target, dir) {
    target.classList.remove('none');
    switch (dir) {
        case 'left':
            target.classList.remove(nav_scss_1.default.appearLeft);
            break;
        case 'right':
            target.classList.remove(nav_scss_1.default.appearRight);
            break;
        case 'top':
            target.classList.remove(nav_scss_1.default.appearTop);
            break;
        case 'bottom':
            target.classList.remove(nav_scss_1.default.appearBottom);
            break;
    }
}
function setActiveNavItem(navItem, active, dir) {
    if (active && !navItem.active) {
        navItem.active = true;
        navItem.domNode.classList.add(nav_scss_1.default.navItemActive);
        if (navItem.img && navItem.icon) {
            navItem.img.src = navItem.icon.active;
            navItem.img.title = navItem.icon.desc;
        }
        if (navItem.ref) {
            switch (dir) {
                case 'left':
                    navItem.ref.classList.add(nav_scss_1.default.appearLeft);
                    break;
                case 'right':
                    navItem.ref.classList.add(nav_scss_1.default.appearRight);
                    break;
                case 'top':
                    navItem.ref.classList.add(nav_scss_1.default.appearTop);
                    break;
                case 'bottom':
                    navItem.ref.classList.add(nav_scss_1.default.appearBottom);
                    break;
            }
            const cb = () => {
                var _a;
                (_a = navItem.ref) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', cb);
                appearCallback(navItem.ref, dir);
            };
            navItem.ref.addEventListener('animationend', cb);
        }
    }
    else if (!active && navItem.active) {
        navItem.active = false;
        navItem.domNode.classList.remove(nav_scss_1.default.navItemActive);
        if (navItem.img && navItem.icon) {
            navItem.img.src = navItem.icon.inactive;
            navItem.img.title = navItem.icon.desc;
        }
        if (navItem.ref) {
            switch (dir) {
                case 'left':
                    navItem.ref.classList.add(nav_scss_1.default.fadeLeft);
                    break;
                case 'right':
                    navItem.ref.classList.add(nav_scss_1.default.fadeRight);
                    break;
                case 'top':
                    navItem.ref.classList.add(nav_scss_1.default.fadeTop);
                    break;
                case 'bottom':
                    navItem.ref.classList.add(nav_scss_1.default.fadeBottom);
                    break;
            }
            const cb = () => {
                var _a;
                (_a = navItem.ref) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', cb);
                fadeCallback(navItem.ref, dir);
            };
            navItem.ref.addEventListener('animationend', cb);
        }
    }
}
function createNavItem(icon) {
    if (icon) {
        const el = document.createElement('i');
        el.className = nav_scss_1.default.navItem;
        // el.classList.add(clz.navItemActive)
        // const object = document.createElement('object')
        // object.type = 'image/svg+xml'
        // object.data = `image/${icon}.svg`
        // object.width = '48px'
        // object.height = '48px'
        // el.appendChild(object)
        const img = document.createElement('img');
        img.src = icon.inactive;
        img.title = icon.desc;
        // img.style.width = '32px'
        // img.style.height = '32px'
        el.appendChild(img);
        return {
            icon,
            img,
            domNode: el,
            active: false,
            ref: document.querySelector(`#${icon.key}`)
        };
    }
    return createNavLineItem();
}
function createNavLineItem() {
    const el = document.createElement('i');
    el.className = nav_scss_1.default.navLineItem;
    return {
        icon: null,
        active: false,
        domNode: el
    };
}
